import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AccountState {
  country: {
    id: string;
    name: string;
    flag:string
  } | null;

  setCountry: (country: { id: string; name: string,flag:string }) => void;
  clearCountry: () => void;
}

export const useCountryStore = create<AccountState>()((set) => ({
  country: {
    id: 'BD',
    name: 'Bangladesh',
 flag: 'https://flagcdn.com/w40/bd.png'
  },

  setCountry: (country) =>
    set(() => ({
      country,
    })),
  clearCountry: () =>
    set(() => ({
      country: null,
    })),
}));
